// extracted by mini-css-extract-plugin
export default {"List":"List_List__iwEKg","Intro":"List_Intro__Zjvu3","Eyebrow":"List_Eyebrow__u+XMN","Title":"List_Title__gg4YC","Description":"List_Description__Aw8Le","Count":"List_Count__4Zxyt"};